// ==========================================
// API Configuration
// ==========================================

/**
 * Get the API base URL from localStorage or return default
 * @returns {string} - API base URL
 */
export const server_api = () => {
  const storedUrl = localStorage.getItem('host');
  
  // If it exists, return the URL from localStorage
  if (storedUrl) {
    return storedUrl;
  }
  
  // Otherwise, return the default URL
  return 'https://api.prod.webdekho.in:8081';
};

/**
 * Set the API base URL in localStorage
 * @param {string} url - The base URL to save
 */
export const setBaseUrl = (url) => {
  if (url) {
    localStorage.setItem('host', url);
    console.log('Base URL saved:', url);
  }
};

/**
 * Clear the saved base URL from localStorage
 */
export const clearBaseUrl = () => {
  localStorage.removeItem('host');
  console.log('Base URL cleared, using default');
};

/**
 * Get current base URL (use this for API calls)
 */
export const API_BASE_URL = server_api();

// ==========================================
// API Endpoints
// ==========================================
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: '/login/panelLogin',
  LOGOUT: '/auth/logout',
  REFRESH_TOKEN: '/auth/refresh',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  CHANGE_PASSWORD: '/auth/change-password',
  CHANGE_TPIN: '/auth/change-tpin',

  // User Management
  USERS: '/users',
  USER_BY_ID: (id) => `/users/${id}`,
  USER_PROFILE: '/users/profile',
  USER_SEARCH: '/users/search',
  USER_STATUS: (id) => `/users/${id}/status`,

  // Wallet & Transactions
  WALLET_BALANCE: '/wallet/balance',
  WALLET_TRANSACTIONS: '/wallet/transactions',
  WALLET_TRANSACTION_BY_ID: (id) => `/wallet/transactions/${id}`,
  WALLET_ADD_MONEY: '/wallet/add-money',
  WALLET_TRANSFER: '/wallet/transfer',
  WALLET_WITHDRAW: '/wallet/withdraw',
  WALLET_STATEMENT: '/wallet/statement',

  // Payments
  PAYMENT_PROCESS: '/payments/process',
  PAYMENT_STATUS: (id) => `/payments/${id}/status`,
  PAYMENT_HISTORY: '/payments/history',

  // Dashboard & Reports
  DASHBOARD_STATS: '/dashboard/stats',
  REPORTS_GENERATE: '/reports/generate',
  REPORTS_DOWNLOAD: (id) => `/reports/${id}/download`,

  // Add more endpoints as needed
};

// ==========================================
// API Headers
// ==========================================
export const API_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json, text/plain, */*',
};

// ==========================================
// Application Constants
// ==========================================
export const USER_ROLES = {
  ADMIN: 'admin',
  SUPER_DISTRIBUTOR: 'super_distributor',
  MASTER_DISTRIBUTOR: 'master',
  DISTRIBUTOR: 'distributor',
  RETAILER: 'retailer',
  API_PARTNER: 'api_partner',
  SALES_FORCE: 'salesforce',
  EMPLOYEE: 'employee',
  SUPPORT: 'support',
};

export const TRANSACTION_STATUS = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
  PROCESSING: 'processing',
};

export const TRANSACTION_TYPES = {
  CREDIT: 'credit',
  DEBIT: 'debit',
  TRANSFER: 'transfer',
  COMMISSION: 'commission',
  REFUND: 'refund',
};

// ==========================================
// Pagination
// ==========================================
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  MAX_LIMIT: 100,
};

// ==========================================
// Validation Constants
// ==========================================
export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 6,
  MAX_PASSWORD_LENGTH: 20,
  MOBILE_LENGTH: 10,
  MIN_AMOUNT: 1,
  MAX_AMOUNT: 100000,
};

